import SiafLiteApiRepository from "../../external/siafLiteApi";

class PedidosService {
  constructor() {
    this.urlBase = "/faturamento/pedidos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  cancelar(id) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/${id}/cancelar`).get();
  }

  getRelatorioResumido(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/relatorios/resumido`
    ).patch(body);
  }

  getRelatorioTotais() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/relatorios/totais`).get();
  }
}

export default PedidosService;
